<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-tag-multiple"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mx-1 rounded-xl white">
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="tagDetail.name"
                    filled
                    label="Loại dự án"
                    placeholder="Nhập loại dự án"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="tagDetail.description"
                    filled
                    label="Mô tả"
                    placeholder="Nhập mô tả"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn
                    color="primary"
                    width="180"
                    @click="save()"
                >
                  Lưu
                </v-btn>
              </v-col>

            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <p class="font-weight-medium">Chọn màu</p>
                <vue-gpickr v-model="gradient" class="mb-10"/>
                <v-text-field v-model="gradient" class="show_color" outlined readonly></v-text-field>
              </v-col>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {VueGpickr, LinearGradient} from 'vue-gpickr';
import {mapGetters} from "vuex";
import {GET_DETAIL_TAGS, UPDATE_TAG} from "@/store/modules/tags";

export default {
  name: "EditTags.vue",
  components: {
    VueGpickr
  },
  data() {
    let gradient;
    return {
      page: "Sửa Tag",
      gradient,
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách tags",
          disabled: true,
        },
        {
          text: "Sửa tag",
          disabled: false,
        },
      ],
      tag: {
        name: '',
        description: '',
        color: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      tagDetail: "tagDetail",
    }),
  },
  async created() {
    await this.$store.dispatch(GET_DETAIL_TAGS, this.$route.params.id);
    this.gradient = new LinearGradient(JSON.parse(this.tagDetail.object_tag))
  },


  methods: {
    async save() {
      this.tagDetail.color = this.gradient.toString()
      this.tagDetail.object_tag = JSON.stringify(this.gradient.toRaw(), null, "  ")
      await this.$store.dispatch(`${UPDATE_TAG}`, this.tagDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/project_management/tags')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>
.show_color {
  width: 70%;
}
</style>